<template>
    <router-link to="/push-notification" tag="li"><a><i class="fa fa-bell"></i><span>Push Notification</span></a></router-link>
</template>
<script>
export default {
    name: 'sbmptn-nav'
}
</script>



// WEBPACK FOOTER //
// Navigation.vue?08d8a4dd